// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"736":"db2cf3df","918":"74e5904c"}[chunkId] + ".chunk.css";
};